import React,{useEffect} from "react";
import { Avatar, Dropdown, Menu } from "antd";
import { UserOutlined, SettingOutlined, LogoutOutlined, LockOutlined, EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../user/context/AuthContext";
import useGetApi from "../../services/useGetApi";
import { icons } from "../../Assests/icons-imports/icons";

const ProfileMenu = () => {
  const navigate = useNavigate();
  const { confirmLogout, token } = useAuth();

  const [isLoading, courseError, userData, getData] = useGetApi(
      "users/get",
      [],
      true
  );
  
  useEffect(() => {
     getData("users/get");
  }, []);


  const handleMenuClick = ({ key }) => {
    if (key === "logout") {
      confirmLogout();
    } else if (key === "my-profile") {
      navigate("/my-profile");
    } else if (key === "settings") {
      navigate("/settings/system-settings");
    } 
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="my-profile" icon={<UserOutlined />}>
        My Account
      </Menu.Item>     
      <Menu.Item key="settings" icon={<SettingOutlined />}>
        Settings
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="logout" icon={<LogoutOutlined />} danger >
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={['click']} placement="bottomRight">
      {/* <Avatar
        size={40}
        icon={<UserOutlined />}
        style={{ cursor: "pointer" }}
      /> */}
      <img 
        src={
          userData?.image 
            ? `${process.env.REACT_APP_LIVE_BASE_IMAGE_URL_LMS_ADMIN}${userData?.image}`
            : icons?.user_icon
        }
        alt="User"
        className="user-icon"
      />
    </Dropdown>
  );
};

export default ProfileMenu;
